module.exports = __webpack_public_path__ + "img/claim-modal-background.97e201a7.png";